export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/canvas.worker.fe998e96.js");
}
